import logoGoldmund from '../../assets/images/logoGoldmund.jpg';

export const Title = () => (
    <nav className="navi ">
        <img src= {logoGoldmund} alt="Goldmund" className='img-fluid' />
    </nav>
)